import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Container } from 'react-bootstrap';



function Paas() {
  const [selectedOption, setSelectedOption] = useState('');

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleLinkButtonClick = () => {
    let link = '';
    if (selectedOption === '7') {
      link = '../Pdf/PAAAS2024Avance1erTrimestre.pdf';
   } else if (selectedOption === '16') {link = '../Pdf/PAAAS2026.pdf';  
   } else if (selectedOption === '15') {link = '../Pdf/PAAAS20254TOTRIM.pdf';  
   } else if (selectedOption === '14') {link = '../Pdf/PAAAS20253.pdf';  
   } else if (selectedOption === '13') {link = '../Pdf/PAAAS20252.pdf';  
  } else if (selectedOption === '12') {link = '../Pdf/PAAAS20251ER.pdf';  
    } else if (selectedOption === '11') {link = '../Pdf/PAAAS2025.pdf';  
    } else if (selectedOption === '10') {link = '../Pdf/PAAS20244T.pdf';  
    } else if (selectedOption === '9') {link = '../Pdf/PAAS20243T.pdf';  
    } else if (selectedOption === '8') {link = '../Pdf/PAAS20242T.pdf';  
    } else if (selectedOption === '6') {link = '../Pdf/PAAS2024.pdf';
    } else if (selectedOption === '5') {link = '../Pdf/PAAAS2023AVANCEANUAL.pdf';
    } else if (selectedOption === '4') {link = '../Pdf/PAAS2023.pdf';
    } else if (selectedOption === '3') {link = '../Pdf/PAAS2022.pdf';
    } else if (selectedOption === '2') {link = '../Pdf/PAAS2021.pdf';
    } else if (selectedOption === '1') {link = '../Pdf/PAAS2020.pdf';



    }
    window.open(link, '_blank');
  };

  return (
<Container>
      <Row>
        <Col>
        <br></br><br></br><br></br><br></br>

          <Card>
            <Card.Body>
              <div style={{ maxWidth: '300px' }}>
            </div>              
            <Card.Text>Programa Anual de Adquisiciones, Arrendamientos y Servicios</Card.Text>
              <Form.Select
                aria-label="Default select example"
                value={selectedOption}
                onChange={handleOptionChange}
              >
                <option>- - -</option>
                <option value="1">2020</option>
                <option value="2">2021</option>
                <option value="3">2022</option>
                <option value="4">2023</option>
                <option value="5">2023 Avance Anual</option>
                <option value="6">2024</option>
                <option value="7">2024 Primer Trimestre</option>
                <option value="8">2024 Avance Segundo Trimestre</option>
                <option value="9">2024 Avance Tercer Trimestre</option>
                <option value="10">2024 Avance Cuarto Trimestre</option>
                <option value="11">PAAAS 2025</option>
               <option value="12">Avance PAAAS 2025 Primer Trimestre</option>
                <option value="13">Avance PAAAS 2025 Segundo Trimestre</option>
                <option value="14">Avance PAAAS 2025 Tercer Trimestre</option>
               <option value="15">Avance PAAAS 2025 Cuarto Trimestre</option>
               <option value="16">PAAAS 2026</option>






              </Form.Select>
              <Button variant="primary" onClick={handleLinkButtonClick}>Ver</Button>
            </Card.Body>
          </Card>
        </Col>

      </Row>
      </Container>

  );
}

export default Paas